import { render, staticRenderFns } from "./groupMessage.vue?vue&type=template&id=30c739fe&scoped=true"
import script from "./groupMessage.vue?vue&type=script&lang=js"
export * from "./groupMessage.vue?vue&type=script&lang=js"
import style0 from "./groupMessage.vue?vue&type=style&index=0&id=30c739fe&prod&scoped=true&lang=scss"
import style1 from "./groupMessage.vue?vue&type=style&index=1&id=30c739fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c739fe",
  null
  
)

export default component.exports